VP = window.VP || {};

/*
 * lazy load instagram with mobile versions
*/

(function ($) {
  VP.iglazy = {


    init: function () {
      var _this = this;
      if ($(".lazy-instagram:not('.loaded')").length) {
        // console.log("[iglazy] init (queued)");
        _this.eventHandlers();
      }
      else {
        // console.log("no [iglazy]");
      }
    },
    loadIG: function ($elem, loadnext) {

      var _this = this;
      var _url = $elem.data("url");
      var _isvideo = ($elem.data("isvideo") == "1");
      _url = _url.split('?')[0]; // remove any query string

      var triggernext = loadnext == true;

      // console.log("[iglazy] loading instagram... " + _url);
      // Fire off the request to ajax.php
      $elem.addClass("loaded");

      try {
        
        VP.request.get(
          'ig',
          {
            url: _url,
            referrer: window.location.href
          },
          function (response) {
            if (response && response != "") {
              json = JSON.parse(response);
              //console.log(json.html);
              if (json.html) {

                var _hasvideo = (json.html.toLowerCase().indexOf("https://www.instagram.com/tv/") > -1);
                if (_hasvideo && VP.helpers.isMobile()) {
                  // console.log("[iglazy] Detected Video, using full implementation for mobile");
                }
                if (_isvideo) {
                  // console.log("[iglazy] Video Set, using full implementation for mobile");
                }
                if (VP.helpers.isMobile() && !_hasvideo && !_isvideo) {
                  if (json.thumbnail_url_local) {
                    _img_src = json.thumbnail_url_local;  
                  }
                  else {
                    _img_src = json.thumbnail_url;
                  }
                  //_img_src    = _url.replace(/\/$/, "") + "/media/";
                  //https://www.instagram.com/p/BvoXHqilxqc/media/?size=m

                  _img_height = json.thumbnail_height;
                  _img_width = json.thumbnail_width;
                  _author_name = json.author_name;
                  _author_url = "https://www.instagram.com/" + json.author_name; // json.author_url;
                  _provider_name = json.provider_name;
                  _instagram_url = _url;
                  // console.log(_url);

                  if (_author_url.slice(-1) != "/") _author_url += "/";

                  if (_author_name.length > 15) {
                    _author_name = _author_name.substring(0, 13) + "...";
                  }
                  _html = "";
                  _html += "<div class='instagram-embed'><a target='_blank' href='" + _author_url + "' class='ig-head'><div class='ig-icon'></div>" + _author_name + "<div class='ig-view'>View Profile</div></a>";
                  _html += "<a target='_blank'href='" + _instagram_url + "'><img class='instagram-image' src='" + _img_src + "' height='" + _img_height + "' width='" + _img_width + "' style='max-width:" + _img_width + "px;'/></a>";
                  _html += "<a target='_blank' class='ig-footer' href='" + _instagram_url + "'><div class='ig-vm'>View More on Instagram</div><div class='ig-items'><div class='ig-actions'></div><div class='ig-book'></div></div><div class='ig-comment'>Add a comment...<div class='ig-small'></div></div></a>";
                  // console.log("MOBILE IG: ");
                  // console.log(_html);
                  $elem.html(_html);
                }
                else {
                  $elem.html("<div class='instagram-wrap hidelikes'><div class='instagram-container'>" + json.html + "</div><div class='instagram-base'></div></div>");
                  // console.log(json.html);
                  window.instgrm.Embeds.process();
                }

                VP.quicklinks.updateMetrics();
                VP.iglazy.checkBaseSize();
              }
            }
            else {
              // console.log("parse error, Unable to load instagram, it's probably no longer there: " + _url);
            }
          },
          function (error, xhr) {
            // console.log("general error, Unable to load instagram: " + _url);
          },
          function (response) { // always
            if (triggernext) {
              // console.log("trigger next");
              VP.iglazy.loadFirstItem();
            }
          }
        );

      } catch (error) {
        // console.log("[iglazy] ERROR IN GET IG, LOADING NEXT")
        VP.iglazy.loadFirstItem();
        // console.log(error);
      }

    },
    checkBaseSize: function () {
      //  console.log("[iglazy] check base size");
      $igs = $(".instagram-wrap.hidelikes");
      if (!$igs.length) return;
      $igs.each(function () {
        $iframe = $igs.find(".instagram-media");
        $ibase = $igs.find(".instagram-base");
        if ($ibase.length && $iframe.length) {
          $ibase.width($iframe.width());
        }
      });

      $(".instagram-media").each(function () {
        // console.log($(this).width());
        $(this).parents(".instagram-wrap").find(".instagram-base").width($(this).width());
        // console.log($(this).parents(".instagram-wrap").find(".instagram-base").length);
      });
    },
    checkScrollPosition: function () {
      var _this = this;
      $toload = $(".lazy-instagram:not('.loaded')");
      if (!$toload.length) {
        return;
      }
      buffer = $(window).height() * 1.4;  // buffer is a multiple of page height
      windowTop = $(window).scrollTop();
      windowBottom = windowTop + $(window).height() + buffer;

      $toload.each(function () {
        if ($(this).offset().top < windowBottom) {
          _this.loadIG($(this));
        }
      });

    },

    loadFirstItem: function () {
      var _this = this;
      $toload = $(".lazy-instagram:not('.loaded')").first();
      if (!$toload.length) {
        return;
      }

      VP.iglazy.loadIG($toload, true);

      /*      $toload.each(function() {
              _this.loadIG($(this));
            });*/
    },
    eventHandlers: function () {
      var _this = this;

      VP.documentEvents.onDelayInit(VP.iglazy.loadFirstItem);


      VP.documentEvents.onResize(_this.checkBaseSize.bind(_this), true);
      /*
      VP.documentEvents.onScroll( _this.checkScrollPosition.bind( _this ), true );
      setTimeout(function() {
        _this.checkScrollPosition();
      },500);
*/
    }
  };
})(jQuery);
